<template id="layoutTmpl" >
	<v-app id="vappGui" class="vappDefault">
		
		<ct-toolbar appname='appgui' :backurl="backurl" ></ct-toolbar>

		<v-main>
			{{ /* v-container fluid */ }}
			<v-container>
			
				<ct-loading></ct-loading>
				<ct-dialog></ct-dialog>
					
				{{ /* SECTION TITLE */ }}
				<v-row no-gutters>
					<v-col cols="12">
						<h2 color="primary">{{ $t('toolbar.title_appgui')}}</h2>
					</v-col>
				</v-row>

				{{ /* BREADCRUMB */ }}	
				<ct-navbar :backurl="backurl" :breadcrumbs="breadcrumbs" ></ct-navbar>


				<slot></slot>

			</v-container>
		</v-main>
		<ct-footer></ct-footer>
	</v-app>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    props: ['backurl','breadcrumbs'],
}
</script>